<script>
  import ChatPop from  "./ChatPop.svelte"
  import ChatWrapper from "./ChatWrapper.svelte"

  let open = false
</script>


<ChatPop bind:open={open}/>
<ChatWrapper bind:open={open}/>